"use strict";
/**
 * Draft Review Database Record Types
 *
 * DynamoDB record types for the draft pattern review invitation system.
 * All records live in the same single table as other project records.
 */
Object.defineProperty(exports, "__esModule", { value: true });
